import styles from './button.module.css'
import { SIZE_CLASS, VARIANT_CLASS } from './button-variant'
import type { ButtonSize, ButtonVariant } from './button-variant'
import { TONE_CLASS } from './tones'
import type { ActionTone } from './tones'

/**
 * La receta de clases del botón, compartida por `Button` y `ButtonLink`: los dos se ven igual y
 * solo cambia el elemento que emiten. Vive fuera de los componentes para no romperles el
 * fast-refresh (`react-refresh/only-export-components`).
 *
 * La clase de tono va siempre, `primary` incluido: la tabla vive en `tones.module.css` y un módulo
 * no puede llevar por default una property que declara otro. La variante sí conserva su default en
 * `.au-btn`. `className` va último para que el call site pueda pisar.
 */
export function buttonClasses(
  tone: ActionTone,
  variant: ButtonVariant,
  size: ButtonSize,
  icon: boolean,
  className?: string,
) {
  return [
    styles['au-btn'],
    'au-focusable',
    TONE_CLASS[tone],
    VARIANT_CLASS[variant],
    SIZE_CLASS[size],
    icon && styles['au-btn--icon'],
    className,
  ]
    .filter(Boolean)
    .join(' ')
}
